<template>
  <!-- START : Suggested Products Wrap -->
  <div>
    <!-- START : Suggested Product List -->
    <WCProductRow
      v-for="list in recommendedLists"
      :key="list.type"
      class="suggested-products"
      :class="`suggested-products--${list.rowIdPrefix}`"
      :rowId="getRowId(list.rowIdPrefix)"
      :rowName="list.title"
      :hideIfEmpty="true"
    />
    <!-- END : Suggested Product List -->
  </div>
  <!-- END : Suggested Products Wrap -->
</template>
<script>
import WCProductRow from '@/components/WCProductRow/WCProductRow.vue';

/**
 * Recommended product types
 */
const RECOMMENDED_LIST_TYPES = {
  SUBSTITUTE_ITEMS: 'SUBSTITUTE_ITEMS',
  GOES_WELL_WITH_ITEMS: 'GOES_WELL_WITH_ITEMS',
  RECOMMENDED_ITEMS: 'RECOMMENDED_ITEMS',
  FREQUENTLY_BOUGHT_ITEMS: 'FREQUENTLY_BOUGHT_ITEMS',
};

/**
 * Recommended products config
 *
 * type - Recommended list type
 * title - Recommended list Product Row Title
 * rowIdPrefix - row id prefix. Example: rowId = MIT1INV-1000-92014 where rowIdPrefix = MIT1
 */

export default {
  components: {
    WCProductRow,
  },
  props: {
    productId: {
      type: String,
      required: true,
    },
  },

  methods: {
    /**
     * Method to get row id based on rowIdPrefix
     * @param {String} - rowIdPrefix - rowIdPrefix from config
     */
    getRowId(rowIdPrefix) {
      return `${rowIdPrefix}${this.productId}`;
    },
  },
  computed: {
    recommendedLists() {
      return [
        {
          type: RECOMMENDED_LIST_TYPES.SUBSTITUTE_ITEMS,
          title: this.$configuration.recommendedSubstitutesLabel || 'Recommended Substitutes',
          rowIdPrefix: 'MIT1',
        },
        {
          type: RECOMMENDED_LIST_TYPES.GOES_WELL_WITH_ITEMS,
          title: this.$configuration.goesWellWithLabel || 'Goes Well With',
          rowIdPrefix: 'MIT0',
        },
        {
          type: RECOMMENDED_LIST_TYPES.RECOMMENDED_ITEMS,
          title: this.$configuration.youMayAlsoLikeLabel || 'You May Also Like',
          rowIdPrefix: 'REC',
        },
        {
          type: RECOMMENDED_LIST_TYPES.FREQUENTLY_BOUGHT_ITEMS,
          title:
            this.$configuration.frequentlyBoughtItemLabel || 'Frequently bought with this item',
          rowIdPrefix: 'FBI',
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

/*----- START : Suggested Products -----*/
.suggested-products {
  padding: $pad-3 0;

  &:first-of-type {
    margin-top: $margin-5;
    margin-left: -$container-gutter;
    margin-right: -$container-gutter;
    border-top: 0.5rem solid var(--gray-200, $gray-200);
    padding: $pad-4 $container-gutter $pad-3;

    @include media-breakpoint-down(md) {
      padding-top: $pad-3;
      margin-top: 0;
    }
  }
}
/*----- END : Suggested Products -----*/
</style>
